import { useEffect, useState } from "react";
import moment from "moment";
import { getMeetAssistPrice } from "../../../../actions/admin/settings";
import {
    isNightHours,
    createMeetAssistPriceStructure,
    calculateVipMeetAssistPrice,
    getTotalPax,
} from "../utils";

export function useMeetAssist({ formatedTravelDate, pickupTime, passengers }) {
    const [meetAssistS, setMeetAssistS] = useState([
        {
            meetAssistType: "arrival",
            meetAssistName: "none",
            meetAssistPrice: 0,
        },
        {
            meetAssistType: "departure",
            meetAssistName: "none",
            meetAssistPrice: 0,
        },
    ]);

    const [meetAssistPrice, setMeetAssistPrice] = useState({
        pickup: {
            meetAssistBasePrice: 0,
            vipMeetAssistBasePrice: 0,
            vipMeetAssistAdditionalPrice: 0,
        },
        dropoff: {
            meetAssistBasePrice: 0,
            vipMeetAssistBasePrice: 0,
            vipMeetAssistAdditionalPrice: 0,
        },
    });

    useEffect(() => {
        const fetchMeetAssistPricing = async () => {
            try {
                const prices = await getMeetAssistPrice();
                const pickupDateTime =
                    formatedTravelDate && pickupTime
                        ? moment(
                            `${formatedTravelDate} ${pickupTime}`,
                            ["YYYY-MM-DD h:mm A", "YYYY-MM-DD HH:mm"],
                            true
                        ).toDate()
                        : null;
                const isPickupNight = isNightHours(pickupDateTime);
                const isDropoffNight = false;
                setMeetAssistPrice(
                    createMeetAssistPriceStructure(prices, isPickupNight, isDropoffNight)
                );
            } catch (error) {
                console.error("Error fetching meet assist price:", error);
            }
        };

        fetchMeetAssistPricing();
    }, [formatedTravelDate, pickupTime]);

    const onChangeMeetAssist = (type, value) => {
        const totalPax = getTotalPax(passengers);

        setMeetAssistS((prev) =>
            prev.map((item) => {
                if (item.meetAssistType !== type) return item;

                const priceSource =
                    type === "arrival" ? meetAssistPrice.pickup : meetAssistPrice.dropoff;
                const nextPrice =
                    value === "vipMeetAssist"
                        ? calculateVipMeetAssistPrice(
                            priceSource.vipMeetAssistBasePrice,
                            priceSource.vipMeetAssistAdditionalPrice,
                            totalPax
                        )
                        : value === "meetAssist"
                            ? priceSource.meetAssistBasePrice
                            : 0;

                return {
                    ...item,
                    meetAssistName: value,
                    meetAssistPrice: nextPrice,
                };
            })
        );
    };

    return {
        meetAssistS,
        setMeetAssistS,
        meetAssistPrice,
        onChangeMeetAssist,
    };
}
